module.exports = __webpack_public_path__ + "images/cordial-thumb__2Ivpw.jpg";